import React from 'react';
import PropTypes from 'prop-types';
import ReactImageGallery from 'react-image-gallery';
import ImageProp from '../propTypes/imageProp';
import translate from '../translate';

function ImageGallery({
  t,
  images,
  onLastImage,
  onCompleteLesson,
  lessonIsDone,
  alreadyCompleted,
}) {
  const handleGallerySlide = index => {
    if (index === images.length - 1) {
      onCompleteLesson();
    }
  };

  return (
    <div className="image-gallery-container">
      <ReactImageGallery
        items={images.map(i => ({ original: i.url, thumbnail: i.thumb }))}
        infinite={false}
        showPlayButton={false}
        showBullets
        onSlide={handleGallerySlide}
      />
      {!alreadyCompleted && lessonIsDone && (
        <button
          type="button"
          onClick={onLastImage}
          className="btn m-btn--pill btn-dynamic image-lesson-complete"
        >
          {t('course.mark.asCompleted')}
        </button>
      )}
    </div>
  );
}

ImageGallery.propTypes = {
  t: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType).isRequired)
    .isRequired,
  onLastImage: PropTypes.func,
  onCompleteLesson: PropTypes.func,
  lessonIsDone: PropTypes.bool,
  alreadyCompleted: PropTypes.bool,
};

ImageGallery.defaultProps = {
  onLastImage: () => null,
  alreadyCompleted: false,
  onCompleteLesson: () => {},
  lessonIsDone: false,
};

export default translate(ImageGallery);
